import { updateUserAttributes } from '../../../../auth/user/domain/use-cases/updateUserAttributes';
import { getStateAbbreviationForName } from '../../../utils/getStateAbbreviationForName';
import { formatE164PhoneNumber } from '../../details/helpers/formatE164PhoneNumber';
import { IDetailsFormData } from '../../details/types/IDetailsFormData';

export async function saveUserDetails(data: IDetailsFormData) {
	await updateUserAttributes({
		family_name: data.lastName,
		given_name: data.firstName,
		phone_number: formatE164PhoneNumber(data.phoneNumber),
		email: data.email,
		address: {
			street_address: data.address,
			locality: data.city,
			postal_code: data.zipCode,
			region: getStateAbbreviationForName(data.state),
		},
	});
}
